import styled from "styled-components";

export const StyledVideo = styled.video`
  width: 100%;
  max-width: 368px;
  border-radius: ${({ theme }) => theme.radii.semiMedium};
`;
